/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs */

const en_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create guides`)
};

const de_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleitungen erstellen`)
};

const es_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear manuales`)
};

const fr_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer des tutoriels`)
};

const nl_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handleidingen maken`)
};

const it_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea guide`)
};

const pt_br2_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar guias`)
};

const pl_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz przewodniki`)
};

const hu_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Útmutatók létrehozása`)
};

const ro_admin_dashboard_empty_state_help_desk_create_guides = /** @type {(inputs: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creati ghiduri`)
};

/**
* | output |
* | --- |
* | "Create guides" |
*
* @param {Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_help_desk_create_guides = /** @type {((inputs?: Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Help_Desk_Create_GuidesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_help_desk_create_guides(inputs)
	return ro_admin_dashboard_empty_state_help_desk_create_guides(inputs)
});
export { admin_dashboard_empty_state_help_desk_create_guides as "admin.dashboard.empty_state.help_desk.create_guides" }